import React from "react";
import {useForm, FormProvider} from "react-hook-form";

import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import * as EmployeeFragment from './EmployeeFragmentComponent';



function EmployeeFullRederer(props) {
    const methods = useForm({
        defaultValues: {
            lEmployee: props.employee

        } 
    });

    const handleSubmit = methods.handleSubmit;

    const handleSubmitEData = (data) => {
        console.log('Current State is: ' + JSON.stringify(data));

        const employee = data.lEmployee;
        props.saveEmployee(employee);

    }


    return(

        <React.Fragment>

        <FormProvider {...methods} > 
        <form onSubmit={handleSubmit( handleSubmitEData )} id={'eForm'}>

            {/**********   Date Generale   **********/}
            <EmployeeFragment.RenderPersonalDataSection />
            {/* <EmployeeFragment.RenderDomiciliuStabil />
            <EmployeeFragment.RenderDomiciliuFlotant /> */}

            <EmployeeFragment.RenderEmployment 
                employers={props.employers} 
                corCodes={props.corCodes}
            />


            <Box sx={{ width:'100%', marginBottom: 2, marginTop: 1}} display="flex" justifyContent="flex-end" alignItems="flex-end">
                <Button variant="outlined" type="submit" sx={{ marginRight: 1}}>Salveaza Angajat</Button>
            </Box>

        </form>
        </FormProvider>


        </React.Fragment>

    );
}

export default EmployeeFullRederer;